export const CODE_REQUIRED_PATTERN = 'GB';

export const VatNumber = [
    {
        id: 1,
        country: 'Austria',
        code: 'AT'
    },
    {
        id: 2,
        country: 'Belgium',
        code: 'BE'
    },
    {
        id: 3,
        country: 'Bulgaria',
        code: 'BG'
    },
    {
        id: 4,
        country: 'Croatia',
        code: 'HR'
    },
    {
        id: 5,
        country: 'Cyprus',
        code: 'CY'
    },
    {
        id: 6,
        country: 'Czech Republic',
        code: 'CZ'
    },
    {
        id: 7,
        country: 'Denmark',
        code: 'DK'
    },
    {
        id: 8,
        country: 'Estonia',
        code: 'EE'
    },
    {
        id: 9,
        country: 'Finland',
        code: 'FI'
    },
    {
        id: 10,
        country: 'France',
        code: 'FR'
    },
    {
        id: 11,
        country: 'Germany',
        code: 'DE'
    },
    {
        id: 12,
        country: 'Greece',
        code: 'GR'
    },
    {
        id: 13,
        country: 'Hungary',
        code: 'HU'
    },
    {
        id: 14,
        country: 'Ireland',
        code: 'IE'
    },
    {
        id: 15,
        country: 'Italy',
        code: 'IT'
    },
    {
        id: 16,
        country: 'Latvia',
        code: 'LV'
    },
    {
        id: 17,
        country: 'Lithuania',
        code: 'LT'
    },
    {
        id: 18,
        country: 'Luxembourg',
        code: 'LU'
    },
    {
        id: 19,
        country: 'Malta',
        code: 'MT'
    },
    {
        id: 20,
        country: 'Netherlands',
        code: 'NL'
    },
    {
        id: 21,
        country: 'Poland',
        code: 'PL'
    },
    {
        id: 22,
        country: 'Portugal',
        code: 'PT'
    },
    {
        id: 23,
        country: 'Romania',
        code: 'RO'
    },
    {
        id: 24,
        country: 'Slovakia',
        code: 'SK'
    },
    {
        id: 25,
        country: 'Spain',
        code: 'ES'
    },
    {
        id: 26,
        country: 'Sweden',
        code: 'SE'
    },
    {
        id: 27,
        country: 'United Kingdom and Isle of Man',
        code: CODE_REQUIRED_PATTERN
    }
]